<div class="sidebar" [class.collapsed]="isCollapsed" [class.labeled]="!!envLabel">
  <div class="sidebar-header">
    <div class="logo-container">
      <a [routerLink]="['/']"><img src="/assets/images/logo_white.png" alt="GIP" class="logo" /></a>
    </div>
    <div class="env-label" *ngIf="envLabel">{{ envLabel }}</div>
  </div>
  <div class="menu-container">
    <p-panelMenu [model]="items" styleClass="w-full sidebar-menu">
      <ng-template #item let-item>
        <ng-container *ngIf="item.route; else urlRef">
          <a
            [routerLink]="item.route"
            routerLinkActive="active-route"
            [routerLinkActiveOptions]="{
              paths: item.rule,
              queryParams: 'ignored',
              fragment: 'ignored',
              matrixParams: 'ignored'
            }"
            class="flex align-items-center cursor-pointer"
          >
            <span [class]="item.icon"></span>
            <span [class]="item.icon ? 'ml-2' : ''">{{ item.label }}</span>
          </a>
        </ng-container>
        <ng-template #urlRef>
          <a *ngIf="item.url; else noLink" [href]="item.url" [target]="item.target" class="flex align-items-center cursor-pointer">
            <span [class]="item.icon"></span>
            <span [class]="item.icon ? 'ml-2' : ''">{{ item.label }}</span>
          </a>
          <ng-template #noLink>
            <span class="flex items-center cursor-pointer">
              <span [class]="item.icon"></span>
              <span [class]="item.icon ? 'ml-2' : ''">{{ item.label }}</span>
              <i *ngIf="item.items" class="pi pi-chevron-right ml-auto"></i>
            </span>
          </ng-template>
        </ng-template>
      </ng-template>
    </p-panelMenu>
  </div>
  <p-button class="collapse-btn" [icon]="isCollapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'" [rounded]="true" (click)="toggleSidebar()"/>
</div>
